export default {
  alertColor: '#0C8ED7',
  noIssueColor: '#dbb167',
  customerViewBarChartColor: '#3796A6',
  autoCloseColor: '#4CAF50',
  strColor: '#E85252',
  strProgressColor: '#E85252',
  conversionColor: '#8971E9',
  ruleBasedColor: '#F5C987',
  issueColor: '#FF934F',
  anomalyColor: '#A18CE8',
  anomalyProgressColor: '#BC23DA',
  noColor: '#666',
  randomColor: random_rgba
};

// export default {
//   alertColor: "#0C8ED7",
//   noIssueColor: "#9ED85B",
//   autoCloseColor: "#4CAF50",
//   strColor: "#E85252",
//   conversionColor: "#8971E9",
//   ruleBasedColor: "#F5C987",
//   issueColor: "#FF934F",
//   anomalyColor: "#BC23DA",
//   noColor: "#666",
//   randomColor: random_rgba
// }

function random_rgba() {
  var o = Math.round,
    r = Math.random,
    s = 255;
  return (
    'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + 0.8 + ')'
  );
}

export const nsColorConstants = {
  alerts: '#3184dc',
  hits: '#FF934F',
  falseHits: '#6E78B9',
  trueHits: '#FF1E00',
  undetermined: '#3786A6',
  autoClosed: '#579C87',
  hitsYield: '#8971E9',
  ruleBasedColor: '#F5C987',
  throughPut: '#335777',
  peerAvg: '#6bbed7',
  time: '#69050ccc',
  randomColor: random_rgba()
};

export const defaultSliderStartVal = 0;
export const defaultSliderEndVal = 5000;

export const tmDefaultPageSize = 20;

export const dateTimeFormat = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const DDMMYYYYFormat = 'DD/MM/YYYY';
export const DDMMYYYYTimeFormat = 'DD/MM/YYYY HH:mm:ss';
export const DDMMYYYYHHMMTimeFormat = 'DD/MM/YYYY HH:mm';
export const DDMMYYYYHHMMTimeFormatForFileDownload = 'DD-MM-YYYY_HHmm';
export const YYYYMMDDFormat = 'YYYY/MM/DD';
export const YYYYMMDDFormatWithHyphen = 'YYYY-MM-DD';
export const YYYYMMDDCompactFormat = 'YYYYMMDD';
export const timezoneDiffTimeFormat = 'Z';
export const timezoneTextFormat = 'z';

export const TM_FRAUD_SOURCE_IDS = {
  TM: '8',
  FRAUD: '20',
  TM_PROD_ID: '6',
  FRAUD_PREVENTION_ID: '24',
  REAL_TIME_FRAUD: '24',
  FRAUD_PROD_ID: '21',
  FRAUD_PREV_ID: '24',
  TM_FRAUD_ID: '8,20',
  TM_PREV_ID: '8,24'
};

export const TM_FRAUD_PREVENTION_SOURCE_MAPPING = {
  TM_AML: 'AML-TM',
  FRAUD_PREVENTION: 'Fraud Prevention',
  FRAUD_DETECTION: 'Fraud Detection'
};

export const TM_FRAUD_SOURCE_STRINGS = {
  TMIAD: 'TMIAD',
  TMIAD_RUN_INSTANCE: 'TMIAD_RUN_INSTANCE',
  FRAUDIAD: 'FRAUDIAD',
  RTFRAUDIAD: 'RTFRAUDIAD',
  RTFRAUDIAD_BATCH: 'RTFRAUDIAD_BATCH'
};

export const AMLS_MODULES_AND_ALERT_SOURCE_MAPPING = [
  { value: '7', mapping: ['NS', 'NAME SCREENING'], label: 'Name Screening' },
  {
    value: '9',
    mapping: ['TS', 'TRANSACTION SCREENING'],
    label: 'Transaction Screening'
  },
  {
    value: '16',
    mapping: ['PS', 'PROSPECT SCREEINING'],
    label: 'Prospect Name Screening'
  },
  {
    value: '17',
    mapping: ['RS', 'RISK SCORING'],
    label: 'Risk Scoring'
  }
];

export const ALERT_SOURCE_MAPPING = {
  NS: '7',
  TS: '9',
  PS: '16',
  RS: '17',
  PSRS: '16,17'
};

export const MODULE_SOURCEID_MAPPING = {
  'NS-IAD': '7',
  'TS-IAD': '9',
  PS: '16',
  RS: '17',
  PRS: '17'
};

export const ALERT_SOURCEID_MAPPING = {
  2: 'NS',
  7: 'NS',
  9: 'TS',
  13: 'TS',
  16: 'PS',
  18: 'PS',
  27: 'NS',
  28: 'NS',
  30: 'NS'
};

export const SCREENING_MODULEID_LIST = ['4', '5', '6', '7', '9', '10'];

export const GLOBAL_SETTINGS_SOURCE_MAPPING = {
  NS: {
    pageId: 'NS_IAD_ALERT_DETAILS',
    topPanelWidgetId: 'NS_IAD_ALERT_BASIC_DETAILS',
    topPanelWidgetGoupId: 'NS_IAD_ALERT_DETAILS_TOP_PANEL_GROUP',
    identityWidgetId: 'NS_IAD_ALERT_PARTY_IDENTITY',
    identityAndhitsExplainabilityWidgetGroupId:
      'NS_IAD_ALERT_PARTY_IDENTITY_AND_EXPLAINABILITY',
    hitsExplainabilityWidgetId: 'NS_IAD_HITS_AND_EXPLAINABILITY'
  },
  TS: {
    pageId: 'TS_IAD_ALERT_DETAILS',
    topPanelWidgetId: 'TS_IAD_ALERT_BASIC_DETAILS',
    topPanelWidgetGoupId: 'TS_IAD_ALERT_DETAILS_TOP_PANEL_GROUP',
    identityWidgetId: 'TS_IAD_ALERT_ENTITY_IDENTITY',
    identityAndhitsExplainabilityWidgetGroupId:
      'TS_IAD_ALERT_ENTITY_IDENTITY_AND_EXPLAINABILITY',
    hitsExplainabilityWidgetId: 'TS_IAD_HITS_AND_EXPLAINABILITY'
  },
  PS: {
    pageId: 'NS_IAD_ALERT_DETAILS',
    topPanelWidgetId: 'NS_IAD_ALERT_BASIC_DETAILS',
    topPanelWidgetGoupId: 'NS_IAD_ALERT_DETAILS_TOP_PANEL_GROUP',
    identityWidgetId: 'NS_IAD_ALERT_PARTY_IDENTITY',
    identityAndhitsExplainabilityWidgetGroupId:
      'NS_IAD_ALERT_PARTY_IDENTITY_AND_EXPLAINABILITY',
    hitsExplainabilityWidgetId: 'NS_IAD_HITS_AND_EXPLAINABILITY'
  }
};

export const ITEM_OPERATIONS = {
  CREATE: 'Write',
  READ: 'Read',
  EDIT: 'Update',
  DELETE: 'Delete',
  EXECUTE: 'Execute',
  FULL: 'Full'
};

export const dateFormat_DD_MM_YY = 'DD/MM/YYYY';
export const underScore_format_DD_MM_YY = 'DD_MM_YYYY';
export const DEFAULT_OFFSET = 0;
export const FeatureCategoryCodes_LC = 'featureCategoryCodes';
export const FeatureCodes_LC = 'featureCodes';
export const TransactionProductMapping = 'transactionProductMapping';
export const TransactionTypes = 'transactionTypes';
export const ClusterViewDescription_LC = 'clusterViewDescription';
export const MAX_FRACTION_DIGITS = 6;
export const MIN_FRACTION_DIGITS = 2;
